import plur from 'plur';

const numberFormatter = new Intl.NumberFormat('en-US');

export const formatNumber = (num: number) => numberFormatter.format(num);

export const unitRangeText =
  (unit: string) => (min: number, max: number, total: number) =>
    `${formatNumber(min)}–${formatNumber(max)} of ${formatNumber(total)} ${plur(
      unit,
      total
    )}`;

export const itemRangeText = unitRangeText('item');

export const pageRangeText = (_current: number, total: number) => {
  return `of ${formatNumber(total)} ${plur('page', total)}`;
};
